import paths from '../../constants/paths';

export const actionsByPriority = {
  show_postponed_upgrade: 0,
  show_initial_offer: 1,
  show_special_offer_2x: 2,
  update_declined_username: 3, // not redirection
  update_declined_tagline: 4, // !!! Redirection
  update_declined_photo: 5, // !!! Redirection
  // 'need_explicit_opt_in': 0, // not redirection
  // 'update_password': 1,
  // 'show_coreg_welcome': 2,
  // 'update_declined_username': 3, // not redirection
  // 'update_declined_tagline': 4, // !!! Redirection
  // 'update_declined_photo': 5, // !!! Redirection
  // 'add_location': 7, // not redirection
  // 'update_sex': 8, // not redirection
  // 'update_username': 9, // not redirection
  // 'update_dob': 10, // not redirection
  // 'add_email': 11, // not redirection
  // 'show_postponed_upgrade': 12,
  // 'upload_photo': 13, // !!! Redirection
  // 'show_initial_upgrade': 14 // !!! Redirection
  // 'show_project_merged_modal' // this is not used in clasic modals but like modalAlert in matchesContainer
  show_nearby_connect_dialog: 18,
};

export const mapActionNameToPath = {
  // 'need_explicit_opt_in': paths.EXPLICIT_OPT_IN, // back - REDIRECTION to ToS, PP and Contact-Us
  // 'update_password': paths.MISSING_PASSWORD, // back
  // 'show_coreg_welcome': paths.COREG_WELCOME, // back - special kind, no modal (button to next step/continue ...)
  update_declined_username: paths.INVALID_USERNAME, // back
  update_declined_tagline: paths.INVALID_TAGLINE, // NO-back - REDIRECTION to Edit Profile
  update_declined_photo: paths.INVALID_PHOTO, // NO-back - REDIRECTION to Edit Profile
  // 'add_location': paths.MISSING_LOCATION, // back
  // 'update_sex': paths.MISSING_GENDER, // back
  // 'update_dob': paths.MISSING_AGE, // back
  // 'add_email': paths.MISSING_EMAIL, // NO-back
  show_postponed_upgrade: paths.WELCOME_BACK,
  show_initial_offer: paths.INITIAL_OFFER,
  show_special_offer_2x: paths.SPEACIAL_OFFER_2X,
  show_nearby_connect_dialog: paths.NEARBY_CONNECT,
  // 'show_initial_upgrade': paths.GO_VIP__SHOW_INIT_UPGRADE,
  // 'upload_photo': paths.MISSING_PHOTO // NO-back - REDIRECTION Upload Photo & Crop Image
  // 'show_project_merged_modal' // this event do not have it's own route, it is used like modalAlert
};

/**
 * Get the next missing rejected modal to show if we have multiple rejected/missing reasons
 * @param array actionsRequired [ "update_declined_username", "upload_photo", ... ]
 * @param object shownActionsRequired { update_declined_username: true, upload_photo: true, ... }
 */
export function getNextMissingRejectionActionByPriority(
  actionsRequired,
  shownActionsRequired
) {
  let filteredActions = filterActionsArray(actionsRequired);
  const sortedActionsByPriority = filteredActions.sort((a, b) => {
    return actionsByPriority[a] > actionsByPriority[b] ? 1 : -1;
  });
  let getNextActionToBeDone;
  sortedActionsByPriority.some((val) => {
    return !Object.prototype.hasOwnProperty.call(shownActionsRequired, val)
      ? ((getNextActionToBeDone = val), true)
      : false;
  });
  return getNextActionToBeDone;
}

/**
 * Remove values from array that app do not recognize, based on actionsByPriority object
 * @param array actionsRequired [ "update_declined_username", "upload_photo", ... ]
 */
export function filterActionsArray(actionsRequired) {
  let array1 = actionsRequired;
  let array2 = Object.keys(actionsByPriority);

  return array1.filter((e1) => {
    return array2.some((e2) => {
      return e1 === e2;
    });
  });
}

const primaryActions = [
  'update_dob',
  'update_sex',
  'update_username',
  'update_password',
  'add_location',
  'add_email',
  'need_explicit_opt_in',
  'update_first_name',
  'update_profile_ext_height',
  'update_profile_ext_ethnicity',
  'update_profile_ext_body_type',
  'update_pref_ages',
  'update_pref_radius',
  'update_tag_line',
];

const secondaryActions = [
  'show_postponed_upgrade',
  'upload_photo',
  'show_initial_offer',
  'show_special_offer_2x',
  'update_declined_username',
  'update_declined_tagline', // redirection to Edit Profile
  'update_declined_photo', // redirection to Edit Profile
  'email_confimation_needed',
  'show_nearby_connect_dialog',
];

const onboardingActions = [...primaryActions, 'upload_photo'];

export function getTotalCountOfSteps(actions) {
  const arr = [];

  actions.forEach((a) => {
    if (onboardingActions.includes(a.action)) {
      arr.push(a.action);
    }
  });

  return arr.length;
}

export function mapAllActions(actions = [], typeOfActions = [], type) {
  const filteredActions = [];

  if (typeOfActions.length > 0) {
    for (let i = 0; i < typeOfActions.length; i++) {
      const action = typeOfActions[i];
      if (actions.includes(action)) {
        filteredActions.push({ action, type });
      }
    }
  }

  return filteredActions;
}

export function getPrimaryActions(actions) {
  return mapAllActions(actions, primaryActions, 'primary');
}

export function getSecondaryActions(actions) {
  return mapAllActions(actions, secondaryActions, 'secondary');
}
